module.exports = __webpack_public_path__ + "img/CSpearman64_ua.b2d5258f.webp";